import React, { useState } from 'react';
import { auth, signInWithPopup, googleProvider, facebookProvider, ailAndPassword, } from './FirebaseConfig';
import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore'; // Import Firestore functions
import { useUser } from './UserContext';
import './css/LoginPopup.css';


function LoginPopup() {
  const { login } = useUser();
  const [isOpen, setIsOpen] = useState(false);



  const db = getFirestore(); // Initialize Firestore

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const createUserInFirestore = async (user) => {
    try {
      const userRef = doc(db, "Users", user.uid); // Reference to Firestore document
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        // Create user document with default values
        await setDoc(userRef, {
          subscription: "0", // Default subscription
          calendar: [],      // Empty calendar
          name: user.displayName || "Unknown User",
          email: user.email || "",
          createdAt: new Date().toISOString(),
        });
        console.log("User document created in Firestore!");
      } else {
        console.log("User document already exists.");
      }
    } catch (error) {
      console.error("Error creating user document:", error);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      login(result.user); // Call your existing login context function
      await createUserInFirestore(result.user); // Add user to Firestore
      togglePopup();
    } catch (error) {
      console.error("Google login error:", error);
    }
  };


  const handleFacebookLogin = async () => {
    try {
      const result = await signInWithPopup(auth, facebookProvider);
      login(result.user); // Store user in context
      await createUserInFirestore(result.user); // Add to Firestore if needed
      togglePopup();
    } catch (error) {
      console.error("Facebook login error:", error);
    }
  };

  return (
    <div>
      <button onClick={togglePopup} className="login-button">Prihlásiť</button>
      {isOpen && (
        <div className="popup-overlay" onClick={togglePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h2>Prihlásiť sa</h2><br />
            <div className="social-login">
              <button type="button" onClick={handleGoogleLogin} className="google-button">
                <i className="fab fa-google icon"></i>Prihlásiť sa cez Google
              </button>
              <button type="button" onClick={handleFacebookLogin} className="facebook-button">
                <i className="fab fa-facebook icon"></i> Prihlásiť sa cez Facebook
              </button>

            </div>
            {/* <div className="email-login">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Vložte svoj email"
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">Heslo</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Vložte svoje heslo"
                />
              </div>

              <button type="button" onClick={handleEmailLogin} className="submit-button">
                Prihlásiť sa cez email
              </button>
            </div> */}
            <button onClick={togglePopup} className="close-button">Zatvoriť</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default LoginPopup;
